module.exports = __webpack_public_path__ + "static/media/15.5378cd5a.svg";